module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "epub:type": "pagebreak",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0007#abbrs"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0008#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0009#ch01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ONE")]), _vm._v("  “Un théâtre est une machine difficile à mouvoir”: Developing a Transatlantic Cultural Institution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0010#ch02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("TWO")]), _vm._v("  Transatlantic Production and Transatlantic Reception: Positioning New Orleans through "), _c('i', [_vm._v("Grand Opéra")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0011#ch03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THREE")]), _vm._v("  Audiences and Publics: Opera in the Sociocultural Fabric of New Orleans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0012#ch04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FOUR")]), _vm._v("  Opera’s Material Culture and the Creation of Global Intimacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0013#ch05"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "epub:type": "pagebreak",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FIVE")]), _vm._v("  Reimagining New Orleans in Operatic Travelogues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0014#epil"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("EPILOGUE")]), _vm._v("  From the Transatlantic to the Global: Beyond the Théâtre d’Orléans")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0015#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0016#au_note"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0017#app1"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0019#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0021#biblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0022#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2248cad7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-bentley-0006.vue
// module id = 69
// module chunks = 0